import React, { useEffect } from 'react';
import maplibregl from 'maplibre-gl';
import { config } from '../config';

const MaplibreMapWithId = ({ mapId }) => {
    useEffect(() => {
        const map = new maplibregl.Map({
            container: 'map',
            style: 'https://api.maptiler.com/maps/streets/style.json?key=I56tGf0JuA4B5fd6g7Qr',
            zoom: 13,
            center: [-74.0060, 40.7128]
        });

        map.on('load', () => {
            console.log("directoryTilesUrl",config.directoryTilesUrl);

            map.addSource('live_tiles', {
                type: 'vector',
                attribution: 'properties',
                url: `${config.directoryTilesUrl}/get_live_tiles?map_id=${mapId}`
            });

            map.addLayer({
                'id': 'live_tiles',
                'source': 'live_tiles',
                'source-layer': 'live_tiles',
                'type': 'circle',
                'paint': {
                    'circle-radius': 2,
                    'circle-color': '#007cbf'
                },
            });

            map.on('click', 'live_tiles', (e) => {
                const coordinates = e.features[0].geometry.coordinates.slice();
                const html = JSON.stringify(e.features[0].properties, null, 2);

                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                new maplibregl.Popup()
                    .setLngLat(coordinates)
                    .setText(html)
                    .setMaxWidth('500px')
                    .addTo(map);
            });

            map.on('mouseenter', 'live_tiles', () => {
                map.getCanvas().style.cursor = 'pointer';
            });

            map.on('mouseleave', 'live_tiles', () => {
                map.getCanvas().style.cursor = '';
            });
        });
    }, [mapId]);

    return <div id="map" style={{ height: '100vh' }} />;
};

export default MaplibreMapWithId;
